import labels from "../../utils/labels";
import skipLinkStyles from "../../styles/UI/skipLink.module.css";

const skipLinks = [
  { href: "#header", label: labels.skipToHeader },
  { href: "#navigation", label: labels.skipToNavigation },
  { href: "#main-content", label: labels.skipToMainContent },
];

const SkipLink = () => {
  return (
    <>
      {skipLinks.map(({ href, label }) => (
        <a key={href} href={href} className={skipLinkStyles.skipLink}>
          {label}
        </a>
      ))}
    </>
  );
};

export default SkipLink;
